import React from 'react';

interface ConfirmationPageProps {
  t: (key: string, params?: Record<string, any>) => string;
  table: string | null;
}

const ConfirmationPage: React.FC<ConfirmationPageProps> = ({ t, table }) => {
  return (
    <div className="info-page">
      <div className="info-box">
        <p className="info-title">{t('assignmentsConfirmedTitle') || 'Sitzplatzwahl bestätigt!'}</p>
        <p>
          {table
            ? <><span>{t('assignmentsConfirmedTable', { table })}</span><br /><span>{t('assignedTable')} <b>{table}</b></span></>
            : t('assignmentsConfirmedText') || 'Ihre Tischauswahl wurde erfolgreich gespeichert.'}
        </p>
        <p>{t('assignmentsConfirmedEmail') || 'Ein Bestätigung Ihrer Tischwahl wurde soeben an Ihre E-Mail-Adresse gesendet.'}</p>
        <p>{t('assignmentsConfirmedEmailSpam') || 'Bitte schauen Sie ggfs. auch in Ihrem Spamordner nach.'}</p>
        <div className="logout-info">
          {t('logoutInfoPageClose') || 'Sie können diese Seite jetzt schließen. Ihre Sitzung wurde beendet.'}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
